import React, { useEffect, useState } from "react";
import { setSimulateurObject } from "../../../actions/simulateur.action";
import { useDispatch } from "react-redux";
import { styles } from "../../../stylesheets/simulateurs.css";
import "../../../stylesheets/simulateursBis.css";
import ButtonYesno from "../../../components/buttons/button.yesno.js";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import SelectDepartement from "../../../components/selects/select.departement";
import Simulateur92 from "../simulateur.A1.12PRO/simulateur.A1.12PRO";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";
import {ToolTipPerso} from "../../../components/selects/tooltip_perso";
import ConventionHonoraires from "../../../components/questions/ConventionHonoraires.js";
import Promesse from "../../../components/questions/Promesse.js";

// Acquisition de biens et droits immobiliers par tous professionnels assujettis à la TVA, (terrains à bâtir ou non, constructions achevées depuis plus de 5 ans) TVA sur le prix total si TVA déduite lors de l'acquisition, TPF réduite -Art 1594 F quinquies-, engagement de revendre dans les 5 ans -CGI Art 1115-)
// simulateur id 6

function Simulateur_A2_8(props) {
  const dispatch = useDispatch();

  let currUser = JSON.parse(localStorage.getItem("user"));
  let currUserDep = 0;
  if (currUser.societe_zip.startsWith("97")) {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 3);
    currUserDep = parseInt(trimedZip);
  } else {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 2);
    currUserDep = parseInt(trimedZip);
  }

  const [departement, setDepartement] = useState(0);
  const [promesse, setPromesse] = useState(0);
  const [pretHypo, setPretHypo] = useState(0);
  const [simu92, setSimu92] = useState(null);
  const currentIdSimu = 6;
  const [montantVente, setMontantVente] = useState(0);
  const [montantPromesse, setMontantPromesse] = useState(0);
  const [montantDeboursAdditionnels, setMontantDeboursAdditionnels] = useState(0);
  const [deboursAdditionnels, setDeboursAdditionnels] = useState(0);
  const [dependances, setDependancesState] = useState([]);

  const handleChange = async (setter, value, key) => {
    if (setter === setDepartement) {
      setDepartement(parseInt(value));
    } else setter(value);
    setInRedux(setter, value, key);
  };

  useEffect(() => {
    if (simu92 !== undefined && simu92 !== null) setDependances(simu92);
  }, [simu92]);

  const handleChangeRemarque = async (value) => {
    localStorage.setItem("remarque", value);
  };

  function setDependances(simu) {
    setInRedux("dependance", simu);
  }

  function setInRedux(setter, value, key) {
    let object = {
      simulateurid: currentIdSimu,
      departementid: parseInt(departement),
      inputs: {
        montant_vente: parseInt(montantVente),
        montant_promesse: parseInt(montantPromesse),
        montant_deb_add: parseInt(montantDeboursAdditionnels),
        debours_additionnels: parseInt(deboursAdditionnels),
        promesse: parseInt(promesse),
        convention_honoraires : parseInt(props.conventionHonoraires), 
      },
      pdfInputs: {
        nombre_convention_honoraires : parseInt(props.nombreConventionHonoraires),
        object_convention_honoraires : props.objectConventionHonoraires,
        montant_convention_honoraires : parseInt(props.montantConventionHonoraires),
        nom_signataire_convention_honoraires : props.nomSignataireConventionHonoraires,
        adresse_signataire_convention_honoraires : props.adresseSignataireConventionHonoraires,
      },
      dependances: dependances,
    };
    //For values coming from components
    if (key) {
      if (key === "promesse") {
        if (value === 0) {
          setMontantPromesse(0)
          Object.assign(object["inputs"], { montant_promesse: parseInt(0) });
        }
        Object.assign(object["inputs"], { promesse: parseInt(value) });
      }
      if (key === "montant_promesse") { Object.assign(object["inputs"], { montant_promesse: parseInt(value) }); }
    }
    //For internal settings
    if (setter === setPretHypo) {
      if (value === 0) {
        setSimu92(null);
        setDependancesState([]);
        object.dependances = [];
      } else {
        object.dependances = dependances;
      }
    }

    if (setter === "dependance") {
      if (dependances.length > 0) object.dependances = dependances;

      if (value !== undefined) {
        let validator = false;

        for (let i = 0; i < object["dependances"].length; i++) {
          if (object["dependances"][i]?.simulateurid === value.simulateurid) {
            object.dependances[i] = value;
            validator = true;
          }
        }

        if (validator === false) {
          object.dependances.push(value);
        }

        setDependancesState(object.dependances);
      }
    }

    if (setter === setMontantVente) { Object.assign(object["inputs"], { montant_vente: parseInt(value) }); }
    if (setter === setMontantDeboursAdditionnels) { Object.assign(object["inputs"], { montant_deb_add: parseInt(value) }); }
    if (setter === setDepartement) { object.departementid = parseInt(value); }
    if (setter === setDeboursAdditionnels) { Object.assign(object["inputs"], { debours_additionnels: parseInt(value) }); }

    if (setter === props.setConventionHonoraires) {
      if(value === 0){
        props.setNombreConventionHonoraires(1);
        props.setObjectConventionHonoraires(null);
        props.setMontantConventionHonoraires(null);
        props.setNomSignataireConventionHonoraires(null);
        props.setAdresseSignataireConventionHonoraires(null);
        Object.assign(
          object["inputs"], { convention_honoraires : parseInt(value) },
          object["pdfInputs"], {
            nombre_convention_honoraires : null,
            object_convention_honoraires : null,
            montant_convention_honoraires : null,
            nom_signataire_convention_honoraires : null,
            adresse_signataire_convention_honoraires : null
          },
        );
      } else {
        Object.assign(object["inputs"], { convention_honoraires : parseInt(value) });
      }
    }

    if (setter === props.setNombreConventionHonoraires) { Object.assign(object["pdfInputs"], { nombre_convention_honoraires : parseInt(value) }); }
    if (setter === props.setObjectConventionHonoraires) { Object.assign(object["pdfInputs"], { object_convention_honoraires : value }); }
    if (setter === props.setMontantConventionHonoraires) { Object.assign(object["pdfInputs"], { montant_convention_honoraires : parseInt(value)}); }
    if (setter === props.setNomSignataireConventionHonoraires) { Object.assign(object["pdfInputs"], { nom_signataire_convention_honoraires : value }); }
    if (setter === props.setAdresseSignataireConventionHonoraires) { Object.assign(object["pdfInputs"], { adresse_signataire_convention_honoraires : value }); }

    if (props.isParent) {
      dispatch(setSimulateurObject(object));
    } else {
    }
  }

  return (
    <div style={styles.container}>
      <div className="cardSimulateur">
        <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id} />

        <TextfieldRemarques handleChange={handleChangeRemarque} />

        <p style={styles.cardSubTitle}>
          Pour la vente, acte tarifé au titre du Tableau 5, n° 54 (Art A444-91). Prêt aux professionnels associé acte
          tarifé au titre du Tableau 5, n° 128 (Art A444-139). Cautionnement associé acte tarifé au titre du Tableau 5,
          n° 111 (Art A444-127).
        </p>

        {props?.isParent === true && props.departements !== "" ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>Département :</div>

            <SelectDepartement
              items={props.departements}
              nameField={"name"}
              defaultValue={currUserDep}
              optionValue={"id"}
              handleChange={handleChange}
              setter={setDepartement}
            />
          </div>
        ) : (
          <></>
        )}

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>Quel est le montant de la vente ?</div>

          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer le montant"}
            setter={setMontantVente}
          />
        </div>

        <Promesse
          handleChange={handleChange}
          setPromesse={setPromesse}
          promesse={promesse}
          setMontantPromesse={setMontantPromesse}
        />

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Y a-t-il des débours additionnels à prévoir ?
            <ToolTipPerso
                title={
                  "Les débours sur les ventes comprennent une somme de 120 euros représentant le coût moyen d'obtention d'un certificat d'urbanisme complet. Pour retirer ce coût, répondre 'non' à la question."
                }
            />
          </div>
          <div>
            <ButtonYesno handleChange={handleChange} setter={setDeboursAdditionnels} fieldUndefined={true} defaultValue={2} />
          </div>
        </div>

        {parseInt(deboursAdditionnels) === 1 ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>Montant des débours additionnels :</div>
            <TextfieldNumber
              handleChange={handleChange}
              type={"number"}
              placeholder={"Indiquer le montant"}
              setter={setMontantDeboursAdditionnels}
            />
          </div>
        ) : (
          <></>
        )}

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>Y a-t-il un prêt hypothécaire ?</div>
          <div>
            <ButtonYesno handleChange={handleChange} setter={setPretHypo} fieldUndefined={false} defaultValue={0} />
          </div>
        </div>

        {parseInt(pretHypo) === 1 ? (
          <>
            <Simulateur92
              // simulateur={props.simulateur}
              // isParent={false}
              // departements={departements}
              simulateur={props.simulateur}
              isParent={false}
              departementId={departement}
              dependances={setSimu92}
            />
          </>
        ) : (
          <></>
        )}

        <ConventionHonoraires
          handleChange={handleChange}
          conventionHonoraires={props.conventionHonoraires}
          setConventionHonoraires={props.setConventionHonoraires}
          nombreConventionHonoraires={props.nombreConventionHonoraires}
          setNombreConventionHonoraires={props.setNombreConventionHonoraires}
          objectConventionHonoraires={props.objectConventionHonoraires}
          setObjectConventionHonoraires={props.setObjectConventionHonoraires}
          montantConventionHonoraires={props.montantConventionHonoraires}
          setMontantConventionHonoraires={props.setMontantConventionHonoraires}
          nomSignataireConventionHonoraires={props.nomSignataireConventionHonoraires}
          setNomSignataireConventionHonoraires={props.setNomSignataireConventionHonoraires}
          adresseSignataireConventionHonoraires={props.adresseSignataireConventionHonoraires}
          setAdresseSignataireConventionHonoraires={props.setAdresseSignataireConventionHonoraires}
        />
      </div>
    </div>
  );
}

export default Simulateur_A2_8;
